// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

export const plansTranslationsHi = {
  'plans.compare.title': 'अपनी योजना चुनें',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / माह',
  'plans.compare.foundation.price': '$15 / माह',
  'plans.compare.pro.price': '$19 / माह',
  'plans.compare.foundation.badge': '150 सीमित स्थान',
  'plans.compare.cta.foundation': 'Founder बनें',
  'plans.compare.cta.pro': 'PRO में अपग्रेड करें',
  'plans.compare.active': 'वर्तमान योजना',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'संदेश सीमा पूर्ण',
  'plans.limit.message.messages': 'आपने संदेश सीमा पूरी कर ली। FOUNDATION या PRO में अपग्रेड करें।',
  'plans.limit.title.storage': 'स्टोरेज सीमा पूर्ण',
  'plans.limit.message.storage': 'आपने स्टोरेज सीमा पूरी कर ली। योजना अपग्रेड करें।',
  'plans.limit.title.invitations': 'आमंत्रण सीमा पूर्ण',
  'plans.limit.message.invitations': 'आपने आमंत्रण सीमा पूरी कर ली। योजना अपग्रेड करें।',
  'plans.founder.remaining': '{count} Founder सीटें बाकी',
  'plans.founder.remaining_last': 'अंतिम {count} Founder सीटें',
  'plans.founder.remaining_limited': 'सीमित: {count} सीटें बाकी',
  'plans.founder.remaining_very_low': 'सिर्फ {count} Founder सीटें बाकी',
  'plans.founder.soldout': 'Founder बिक चुका',
  'plans.limit.reached': 'सीमा पूर्ण — योजना अपग्रेड करें',
  'plans.compare.pro.adjustment_notice': 'सेवा की शर्तों के अनुसार मूल्य समायोजित हो सकता है।',
  'plans.compare.institucional.price': 'कस्टम मूल्य निर्धारण',
  'plans.compare.institucional.title': 'शीर्षक',
  'plans.compare.yourPlan': 'आपकी योजना',
  'plans.modal.title': 'योजना अपग्रेड करें',
  'plans.modal.comparison_title': 'योजना तुलना',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'मुफ्त योजना',
  'plans.free.price': '$0 / माह',
  'plans.free.features.contacts': 'प्रति उपयोगकर्ता अधिकतम 2 संपर्क',
  'plans.free.features.conversations': 'प्रति खाता अधिकतम 2 सक्रिय बातचीत',
  'plans.free.features.no_export': 'प्रति खाता मासिक 30,000 अक्षर; 34/दिन व 1,000/माह संदेश; निर्यात नहीं',
  'plans.free.features.no_advanced': 'फ़ाइल या स्टोरेज नहीं; 30 दिन इतिहास; प्रति उपयोगकर्ता 1 डिवाइस',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder योजना',
  'plans.foundation.price': '$15 / माह',
  'plans.foundation.features.contacts': 'PRO जैसा ही प्रीमियम अनुबंध (प्रति उपयोगकर्ता अधिकतम 100 संपर्क)',
  'plans.foundation.features.conversations': 'असीमित चैट (टेनेंट); PRO जैसी सीमाएँ',
  'plans.foundation.features.badge': 'Founder कार्यक्रम (150 क्रमांकित स्थान)',
  'plans.foundation.features.support': 'Founder स्थान उपलब्ध होने पर USD 15/माह',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro योजना',
  'plans.pro.price': '$19 / माह',
  'plans.pro.features.contacts': 'प्रति उपयोगकर्ता अधिकतम 100 संपर्क',
  'plans.pro.features.conversations': 'असीमित चैट (टेनेंट); 1,667/दिन, 50k/माह संदेश',
  'plans.pro.features.export': 'अधिकतम 50 MB (टेनेंट); निर्यात, अनुवाद व फ़ाइलें योजना अनुसार',
  'plans.pro.features.notifications': 'प्रति उपयोगकर्ता अधिकतम 3 डिवाइस; असीमित आमंत्रण (टेनेंट)',
  'plans.actions.free': 'वर्तमान योजना',
  'plans.actions.foundation': 'Founder बनें',
  'plans.actions.pro': 'PRO में अपग्रेड करें',
  'plans.badges.recommended': 'अनुशंसित',
  'plans.badges.limited': 'सीमित',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': 'प्रति खाता प्रति माह 30,000 वर्ण।',
  'plans.modal.free.line2': 'प्रति उपयोगकर्ता अधिकतम 2 संपर्क।',
  'plans.modal.free.line3': 'प्रति खाता अधिकतम 2 सक्रिय बातचीत।',
  'plans.modal.free.line4': 'कोई फ़ाइल संलग्नक या संग्रहण स्थान नहीं।',
  'plans.modal.free.line5': 'कोई डेटा निर्यात नहीं।',
  'plans.modal.free.line6': 'संदेश इतिहास अधिकतम 30 दिन।',
  'plans.modal.free.line7': 'प्रति उपयोगकर्ता केवल 1 डिवाइस।',
  'plans.modal.premium.line1': 'प्रति खाता प्रति माह 300,000 वर्ण।',
  'plans.modal.premium.line2': 'प्रति उपयोगकर्ता अधिकतम 100 संपर्क।',
  'plans.modal.premium.line3': 'असीमित बातचीत और चैट (tenant)।',
  'plans.modal.premium.line4': 'अधिकतम 50 MB संग्रहण (tenant)।',
  'plans.modal.premium.line5': 'प्रति उपयोगकर्ता अधिकतम 3 डिवाइस।',
  'plans.modal.premium.line6': 'असीमित आमंत्रण (tenant)।',
  'plans.modal.premium.line7': 'योजना सीमाओं के भीतर निर्यात, स्वचालित अनुवाद और फ़ाइलें शामिल हैं।',
  'plans.modal.premium_block_heading': 'इंजन उपयोग सीमाएँ (प्रीमियम)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder कार्यक्रम',
  'plans.modal.foundation.categories_title': 'Founder श्रेएँ ({slots} स्थान)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'स्थान 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'परियोजना का पहला समर्थन करने वाले। अधिकतम ऐतिहासिक प्राथमिकता।',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'स्थान 26–75',
  'plans.modal.foundation.cat_early_desc': 'विशेष मान्यता के साथ शीघ्र समर्थन।',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'स्थान 76–150',
  'plans.modal.foundation.cat_std_desc': '150 स्थानों के भीतर Founder स्थान।',
  'plans.modal.foundation.advantages_title': 'Founder लाभ',
  'plans.modal.foundation.adv1': 'सीमित Founder पूल ({slots} क्रमांकित स्थान) तक पहुँच।',
  'plans.modal.foundation.adv2': 'ArChat के संस्थापक उपयोगकर्ता के रूप में मान्यता।',
  'plans.modal.foundation.adv3': 'उत्पाद अनुभव में Founder बैज और उपस्थिति।',
  'plans.modal.foundation.adv4': 'आपके स्थान (1–150) के अनुसार ऐतिहासिक प्राथमिकता और स्थिति।',
  'plans.modal.foundation.adv5': 'जब तक वर्तमान नीति लागू है, Founder पहुँच से जुड़ा निरंतर लाभ।',
  'plans.modal.pro.tagline': 'मानक प्रीमियम — Founder घटक के बिना',
  'plans.payments_disabled.title': 'सदस्यता',
  'plans.payments_disabled.message': 'सदस्यता धीरे-धीरे सक्रिय की जा रही है। आप उपलब्ध प्लान और उनके लाभ देख सकते हैं।',
  'plans.payments_disabled.confirm': 'ठीक है',
};